module.exports = __webpack_public_path__ + "img/pagofacil.57fc1e45.svg";